import { render, staticRenderFns } from "./buttons.vue?vue&type=template&id=9f7ed290&scoped=true"
import script from "./buttons.vue?vue&type=script&lang=js"
export * from "./buttons.vue?vue&type=script&lang=js"
import style0 from "./buttons.vue?vue&type=style&index=0&id=9f7ed290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7ed290",
  null
  
)

export default component.exports